import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import Login from '../screens/Login';
import LostPassword from '../screens/Login/LostPassword/';
import ChangePassword from '../screens/Login/LostPassword/ChangePassword/';
import NewPassword from '../screens/Login/NewPassword';
import Blacklist from '../screens/Blacklist';
import LicensePlates from '../screens/LicensePlates';
import ReportLicensePlates from '../screens/ReportLicensePlates';
import CamerasConfiguration from '../screens/CamerasConfiguration';
import Cameras from '../screens/Cameras';
import ServicesConfiguration from '../screens/ServicesConfiguration';
import Motives from '../screens/Motives';
import Malls from '../screens/Malls';
import Telegram from '../screens/Telegram';
import ExclusionRules from '../screens/ExclusionRules';

import { container_style, FlexContainer } from '../components/Dashboard/styles';

export default function Routes() {
  return (
    <FlexContainer style={container_style}>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/contrasena-perdida" component={LostPassword} />
        <Route path="/cambiar-contrasena-perdida" component={ChangePassword} />
        <Route path="/cambiar-clave" component={NewPassword} />
        <Route isLogout path="/logout" component={() => {}} />
        <Route isPrivate path="/patentes" component={LicensePlates} />
        <Route isPrivate path="/listas-negras" component={Blacklist} />
        <Route isPrivate path="/camaras" component={Cameras} />
        <Route isPrivate path="/centros-comerciales" component={Malls} />
        <Route isPrivate path="/motivos" component={Motives} />
        <Route isPrivate path="/telegram" component={Telegram} />
        <Route isPrivate path="/lista-exclusion" component={ExclusionRules} />
        <Route
          isPrivate
          accessLevel={1}
          path="/patentes"
          component={LicensePlates}
        />
        <Route
          isPrivate
          accessLevel={1}
          path="/listas-negras"
          component={Blacklist}
        />
        <Route
          isPrivate
          accessLevel={1}
          path="/reportes-patentes"
          component={ReportLicensePlates}
        />
        <Route isPrivate accessLevel={2} path="/camaras" component={Cameras} />
        <Route
          isPrivate
          accessLevel={2}
          path="/centros-comerciales"
          component={Malls}
        />
        <Route isPrivate accessLevel={2} path="/motivos" component={Motives} />
        <Route
          isPrivate
          accessLevel={2}
          path="/configuracion-accesos"
          component={CamerasConfiguration}
        />
        <Route
          isPrivate
          accessLevel={3}
          path="/configuracion-servicios"
          component={ServicesConfiguration}
        />
      </Switch>
    </FlexContainer>
  );
}
